import { render, staticRenderFns } from "./populationAnalysis.vue?vue&type=template&id=708a7c61&scoped=true&"
import script from "./populationAnalysis.vue?vue&type=script&lang=js&"
export * from "./populationAnalysis.vue?vue&type=script&lang=js&"
import style1 from "./populationAnalysis.vue?vue&type=style&index=1&id=708a7c61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a7c61",
  null
  
)

export default component.exports